module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch4_20210921005334_T.51f240bd.jpg";